import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const tier2Areas = [
  { name: "Kendall", slug: "kendall", zips: ["33156", "33176", "33186"] },
  { name: "Pinecrest", slug: "pinecrest", zips: ["33156", "33256"] },
  { name: "Bay Harbor Islands", slug: "bay-harbor-islands", zips: ["33154"] },
  { name: "Key Biscayne", slug: "key-biscayne", zips: ["33149"] },
  { name: "South Miami", slug: "south-miami", zips: ["33143"] },
  { name: "North Miami Beach", slug: "north-miami-beach", zips: ["33162", "33179"] },
];

const serviceKeys = [
  "serviceAreas.svcSliding",
  "serviceAreas.svcHardware",
  "serviceAreas.svcGlass",
];

export default function Tier2Section() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#fefce8] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent text-white text-xs font-bold px-4 py-1.5 rounded-full mb-4">
            {t("serviceAreas.tier2Badge")}
          </span>
          <h2 className="text-2xl md:text-3xl font-black text-secondary mb-3">
            {t("serviceAreas.tier2H2")}
          </h2>
          <p className="text-base text-[#374151]">
            {t("serviceAreas.tier2Sub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tier2Areas.map((area) => (
            <div
              key={area.slug}
              className="bg-white rounded-xl border-2 border-accent p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <h3 className="text-xl font-bold text-secondary mb-3">
                {area.name}
              </h3>

              <span className="inline-block bg-[#fbbf24] text-secondary text-xs font-bold px-3 py-1 rounded-full mb-3">
                {t("serviceAreas.cardTimeTier2")}
              </span>

              <p className="text-xs text-[#374151] mb-4">
                {t("serviceAreas.cardZipLabel")}{area.zips.length > 1 ? t("serviceAreas.cardZipPlural") : ""}: {area.zips.join(", ")}
              </p>

              <div className="mb-4">
                <p className="text-xs font-bold text-[#374151] uppercase tracking-wider mb-2">
                  {t("serviceAreas.cardServicesLabel")}
                </p>
                <div className="space-y-2">
                  {serviceKeys.map((svcKey) => (
                    <div
                      key={svcKey}
                      className="flex items-center gap-2 text-sm text-secondary"
                    >
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-primary" />
                      </span>
                      {t(svcKey)}
                    </div>
                  ))}
                </div>
              </div>

              <Link
                to={`/impact-windows-${area.slug}/`}
                className="inline-flex items-center gap-1 text-sm font-bold text-primary hover:text-primary-dark transition-colors"
              >
                {t("serviceAreas.cardViewPrefix")} {area.name} {t("serviceAreas.cardViewSuffix")}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}